import React from 'react';
import { styled } from '@linaria/react';
import { SoldOutBodyMessage } from 'components/SearchUnavailability/SoldOut/SoldOutBodyMessage';
import { SoldOutBase } from 'components/Unavailability/SoldOut/SoldOutBase';
import { Button } from '@daedalus/atlas/Button';
import { ButtonLink } from '@daedalus/atlas/ButtonLink';
import { Card } from '@daedalus/atlas/Card';
import { Icon } from '@daedalus/atlas/Icon';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
interface UnavailabilityWithPopupTriggerProps {
  handleShowAvailabilityPopup: (e: React.MouseEvent) => void;
  handleChangeDatesClick: (e: React.MouseEvent) => void;
  showViewPopupCalendar?: boolean;
  isLoading?: boolean;
}
const _exp = /*#__PURE__*/() => Card;
export const UnavailabilityWrapper = /*#__PURE__*/styled(_exp())({
  name: "UnavailabilityWrapper",
  class: "u12z8stv",
  propsAsIs: true
});
const _exp3 = /*#__PURE__*/() => Button;
const ChangeDatesButton = /*#__PURE__*/styled(_exp3())({
  name: "ChangeDatesButton",
  class: "c62p0dk",
  propsAsIs: true
});
const ActionButton = ({
  handleShowAvailabilityPopup,
  handleChangeDatesClick,
  showViewPopupCalendar
}: UnavailabilityWithPopupTriggerProps) => {
  if (showViewPopupCalendar) {
    return <ButtonLink size="sm" isCompact iconStart={<Icon name="Calendar" size="sm" />} onClick={handleShowAvailabilityPopup} dataId="AvailabilityCalendarTrigger">
        <FormattedMessageWrapper id="viewCalendar" defaultMessage="View calendar" />
      </ButtonLink>;
  }
  return <ChangeDatesButton variant="secondary" fullWidth onClick={handleChangeDatesClick}>
      <FormattedMessageWrapper id="changeDates" defaultMessage="Change dates" />
    </ChangeDatesButton>;
};
export const UnavailabilityWithPopupTrigger = ({
  handleShowAvailabilityPopup,
  handleChangeDatesClick,
  showViewPopupCalendar,
  isLoading
}: UnavailabilityWithPopupTriggerProps) => {
  return <UnavailabilityWrapper backgroundColorPath="background.neutral.c050" borderRadius="lg">
      <SoldOutBase headerSlot={<SoldOutBodyMessage shouldWrapDates />} contentSlot={isLoading ? <SkeletonLoader height={showViewPopupCalendar ? 22 : 10} /> : showViewPopupCalendar ? <FormattedMessageWrapper id="unavailability.checkDates" defaultMessage="Check out available dates " /> : null} actionSlot={isLoading ? <SkeletonLoader height={22} /> : <ActionButton handleShowAvailabilityPopup={handleShowAvailabilityPopup} handleChangeDatesClick={handleChangeDatesClick} showViewPopupCalendar={showViewPopupCalendar} />} />
    </UnavailabilityWrapper>;
};

require("./UnavailabilityWithPopupTrigger.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./UnavailabilityWithPopupTrigger.tsx");